export default __webpack_public_path__ + "static/media/21.f94cb0ed.jpg";